import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("dea_admin_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

/**
 * Get the public URL for an image stored in object storage,
 * a seed key, or an external URL.
 */
export function imageUrl(path, fallback = null) {
    if (!path) return fallback;
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    if (path.startsWith("seed:")) {
        return SEED_IMAGES[path] || fallback;
    }
    return `${API}/files/${path}`;
}

// Seed image map (also kept on backend, but frontend has them by key)
export const SEED_IMAGES = {
    "seed:hero":
        "https://static.prod-images.emergentagent.com/jobs/a7e20be5-2468-45b8-9b46-fdcb25958081/images/3f0c9338318ac813c692ca42dff57001c9b52c9f19b81efbf1020e92659e824e.png",
    "seed:room_standard":
        "https://static.prod-images.emergentagent.com/jobs/a7e20be5-2468-45b8-9b46-fdcb25958081/images/41e6992a6bb229d358afc40ddccb41503d7d74e2512996b707e19c4bd62e2ef1.png",
    "seed:room_gabina":
        "https://images.pexels.com/photos/33389169/pexels-photo-33389169.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "seed:room_apartment":
        "https://images.pexels.com/photos/35857662/pexels-photo-35857662.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "seed:facility_restaurant":
        "https://static.prod-images.emergentagent.com/jobs/a7e20be5-2468-45b8-9b46-fdcb25958081/images/6d31d7ad25bfc75e1663af8a807ece43739aceeefbda2e8b2fbeddf36babca90.png",
    "seed:facility_bar":
        "https://images.pexels.com/photos/19533257/pexels-photo-19533257.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "seed:facility_market":
        "https://images.unsplash.com/photo-1627206733232-a2d583fa3b2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzZWFzaWRlJTIwcmVzdGF1cmFudCUyMG1lZGl0ZXJyZWFufGVufDB8fHx8MTc3OTI5NTU4Nnww&ixlib=rb-4.1.0&q=85",
    "seed:gallery_beach":
        "https://static.prod-images.emergentagent.com/jobs/a7e20be5-2468-45b8-9b46-fdcb25958081/images/09245d9712d3c393ab8faa7f0ba3bd91081bba630db65a053e79a0ccf07b7033.png",
    "seed:gallery_pool":
        "https://images.pexels.com/photos/15283660/pexels-photo-15283660.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "seed:gallery_exterior":
        "https://images.unsplash.com/photo-1761926545961-252275b47a2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjb2FzdGFsJTIwaG90ZWwlMjByZXNvcnQlMjBwb29sfGVufDB8fHx8MTc3OTI5NTU4Nnww&ixlib=rb-4.1.0&q=85",
};

export function whatsappLink(number, message = "") {
    const cleaned = (number || "").replace(/\D/g, "");
    return `https://wa.me/${cleaned}?text=${encodeURIComponent(message)}`;
}
